<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="标题" prop="id">
                <a-input v-model="queryParam.title" placeholder="请输入标题" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="20">
              <a-form-item label="BMI等级" prop="bmiLevel">
                <a-select v-model="queryParam.bmiLevel">
                  <a-select-option v-for="item in bmiCategory" :value="item.dictValue" :key='item.dictValue'>{{item.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="20">
              <a-form-item label="是否推荐" prop="isRecommend">
                <a-select v-model="queryParam.isRecommend">
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template v-if="advanced">


            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['cookbook:plan:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['cookbook:plan:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cookbook:plan:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['cookbook:plan:export']">
          <a-icon type="download" />导出
        </a-button>-->
        <!-- <table-setting :style="{float: 'right'}" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <CreateFormDate ref="createFormDate" @ok="getList" />

      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}"  :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered">
        <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="image" slot-scope="text, record">
          <img v-viewer style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
            :src="record.image" preview="封面" />
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['cookbook:plan:edit']">
            <a-icon type="edit" />修改
          </a>
          <a @click="handleDelete(record, index)" v-hasPermi="['cookbook:plan:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
          <br>
          <a @click="viewPlanDay(record)" v-hasPermi="['cookbook:plan:edit']">
            <a-icon type="search" />查看食谱日期
          </a>

        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
  import {
    pagePlan,
    listPlan,
    delPlan
  } from '@/api/cookbook/plan'
  import CreateForm from './modules/CreateForm'
  import CreateFormDate from './modules/CreateFormDate'
  import { tableMixin} from '@/store/table-mixin'
  import { getDicts } from "@/api/system/dict/data";
  export default {
    name: 'Plan',
    components: { CreateForm, CreateFormDate },
    mixins: [tableMixin],
    data() {
      return {
        list: [],
        selectedRowKeys: [],
        selectedRows: [],
        // 高级搜索 展开/关闭
        advanced: false,
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        ids: [],
           //索引indexs
        indexs: [], 
        loading: false,
        total: 0,
        current: 0,
        size: 0,
        // bmi等级
        bmiCategory: [],
        // 查询参数
        queryParam: {
          bmiLevel: null,
          weight: null,
          height: null,
          score: null,
          planType: null,
          title: null,
          subTitle: null,
          image: null,
          introduce: null,
          planNotice: null,
          joinNum: null,
          isRecommend: null,
          createType: null,
          pageNum: 1,
          pageSize: 10
        },
        columns: [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 50,
            fixed: 'left',
            scopedSlots: {
              customRender: 'index'
            },
          },
          // {
          //   title: '编号',
          //   dataIndex: 'id',
          //   ellipsis: true,
          //   align: 'center',
          //   width: '10%'
          // },
          {
            title: 'BMI等级',
            dataIndex: 'bmiLevel_dictText',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '体重区间',
            dataIndex: 'weight',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '身高区间',
            dataIndex: 'height',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '评分',
            dataIndex: 'score',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '类型',
            dataIndex: 'planType_dictText',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '标题',
            dataIndex: 'title',
            ellipsis: true,
            align: 'center'
          },
          /*{
            title: '副标题',
            dataIndex: 'subTitle',
            ellipsis: true,
            align: 'center'
          },*/
          {
            title: '封面',
            dataIndex: 'image',
            ellipsis: true,
            align: 'center',
            scopedSlots: {
              customRender: 'image'
            },
          },
          /*{
            title: '介绍',
            dataIndex: 'introduce',
            ellipsis: true,
            align: 'center'
          },*/
          /*{
            title: '计划须知',
            dataIndex: 'planNotice',
            ellipsis: true,
            align: 'center'
          },*/
          /*{
            title: '参与人数',
            dataIndex: 'joinNum',
            ellipsis: true,
            align: 'center'
          },*/
          {
            title: '推荐',
            dataIndex: 'isRecommend_dictText',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '私人定制',
            dataIndex: 'createType_dictText',
            ellipsis: true,
            align: 'center'
          },
          // {
          //   title: '创建时间',
          //   dataIndex: 'createTime',
          //   scopedSlots: {
          //     customRender: 'createTime'
          //   },
          //   ellipsis: true,
          //   align: 'center',
          //   width: 180
          // },
          /*{
            title: '备注',
            dataIndex: 'remark',
            ellipsis: true,
            align: 'center'
          },*/
          {
            title: '操作',
            dataIndex: 'operation',
            width:120,
            scopedSlots: {
              customRender: 'operation'
            },
            align: 'center'
          }
        ]
      }
    },
    filters: {},
    created() {
      this.getList()
      this.initDict()
    },
    activated() {
      this.initDict()
    },
    computed: {},
    watch: {},
    methods: {
      /** 查询食谱计划列表 */
      getList() {
        this.loading = true
        pagePlan(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.current = response.data.current
          this.size = response.data.size
          this.loading = false
        })
      },

      viewPlanDay(record){
        this.$router.push({path:'/cookbook/plan/dayInfo/index',query:{planId:record.id}})
      },
      /** 获取字典信息 **/
      initDict() {
        getDicts('bmi_level').then(res => {
          this.bmiCategory = res.data
        })
      },

      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParam.pageNum = 1
        this.getList()
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.queryParam = {
          bmiLevel: undefined,
          weight: undefined,
          height: undefined,
          score: undefined,
          planType: undefined,
          title: undefined,
          subTitle: undefined,
          image: undefined,
          introduce: undefined,
          planNotice: undefined,
          joinNum: undefined,
          isRecommend: undefined,
          createType: undefined,
          pageNum: 1,
          pageSize: 10
        }
        this.handleQuery()
      },
      onShowSizeChange(current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize(current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.ids = this.selectedRows.map(item => item.id)
         // 列表顶部删除indexs
         if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
        this.single = selectedRowKeys.length !== 1
        this.multiple = !selectedRowKeys.length
      },
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1   
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
            return delPlan(data)
              .then(() => {
                that.onSelectChange([], [])
                that.getList()
                that.$message.success(
                  '删除成功',
                  3
                )
              })
          },
          onCancel() {
            //取消清空删除ids列表
            // that.ids = []
          }
        })
      },
      /** 导出按钮操作 */
      handleExport() {
        var that = this
        this.$confirm({
          title: '是否确认导出?',
          content: '此操作将导出当前条件下所有数据而非选中数据',
          onOk() {
            that.download('cookbook/plan/export', {
              ...that.queryParam
            }, `食谱计划_${new Date().getTime()}.xlsx`)
          },
          onCancel() {}
        })
      }
    }
  }
</script>
